import React, { useState, useEffect } from "react";
import { TextField, Button, Box, Typography } from "@mui/material";
import ReusableSSHAPI from "../ReusableSSHAPI";
import { SSHService, useEncryptService } from "../../../../shared/hooks";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { resetUserTypeFlags, setIsBothCloudAndPremAssetUser, setIsNewUserTrue, setIsOnlyCloudUser, setIsOnlyPremAssetUser } from "../../../../modules/authentication/login/Login_Details_slice";
import { useDispatch } from "react-redux";
import axiosInstance from "../../../../axios/axios";
import { END_POINTS } from "../../../../shared/endpoints";

interface Props {
    onDirty: (dirty: boolean) => void; // Tracks dirty state for unsaved changes
    onSubmit?: () => void; // Optional callback on submit
    vendorList: any[]; // ✅ Accepts vendor list pro
    scheduleOptions?: FrequencyOptions;
    vendorSelected?: any;  // Make selectedVendor optional
    
}

interface FrequencyOptions {
    frequency?: any;
    timeZone?: any;
    date?: any;
    timeOptions?: any;
    Days?: any;
    timeNowOptions?: any;
}

const APIComponent: React.FC<Props> = ({
    onDirty,
    vendorList,
    scheduleOptions,
    vendorSelected,  
    onSubmit 
    }) => {
        const { doEncryptLogin } = useEncryptService();
        const navigate = useNavigate();
        const dispatch = useDispatch();
    

    // Handle form submission
    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();

        

        if (onSubmit) onSubmit();
    };

      const assetCount = async ()=>{
    console.log("assetCount called");
  dispatch(resetUserTypeFlags());
    

    const res = await axiosInstance.get(END_POINTS.IS_NEW_USER);
        let parsed = null;
        if (res.status === 200) {
          dispatch(setIsOnlyPremAssetUser({ isOnlyPremAssetUser: false }));
    dispatch(setIsOnlyCloudUser({ isOnlyCloudUser: false }));
    dispatch(setIsBothCloudAndPremAssetUser({ isBothCloudAndPremAssetUser: false }));
          const isNewUser = res?.data?.data || false;
          parsed = res?.data?.data || false;
          if (parsed.device_count == 0 && parsed.cloud_count == 0) {
            dispatch(setIsNewUserTrue({ isNewUserTrue: true }));
            //dispatch(setIsOnlyCloudUser({ is: true }));

          } 
          else if (parsed.device_count > 0 && parsed.cloud_count == 0) {
            dispatch(setIsOnlyPremAssetUser({ isOnlyPremAssetUser: true }));
          } else if (parsed.device_count == 0 && parsed.cloud_count > 0) {
            dispatch(setIsOnlyCloudUser({ isOnlyCloudUser: true }));
          } else if (parsed.device_count > 0 && parsed.cloud_count > 0) {
            dispatch(setIsBothCloudAndPremAssetUser({ isBothCloudAndPremAssetUser: true }));
          }
        }
  }

    const handleCallbackFromSSH = async (data: any) => {
        console.log("Message from ReusableSSHAPI:");
        //console.log(data.vendor,'vendor in api comp');
        data.scan_type='api';
        if (data.selectedCredential === "Create New Credential") {
            data.new_cred = true;
            if(data.loginParameter=='password'){
                data.password = doEncryptLogin(data.password);
            } else {

              data.api_token = doEncryptLogin(data.password);
              delete data.password;
            }            
            //const temp:any = data.component=='ssh'?0:1;
            const APIType = data.credentialsTypes[1].password_type.find((type: { code: string; }) => type.code === data.loginParameter);
              if (APIType) {
            data.credential_type_id = APIType.id;
            }
            

            data.description = "";
            // if (execPassword) {
            //     ssh_data.enable_password = doEncryptLogin(execPasswordText)
            // }
            //data.cred_name = data.credName;





        }
        delete data.credentialsTypes;
        delete data.component;
        delete data.encrypt;
        //delete data.password;

        try {
                // Call the SSHService to submit data
                const response = await SSHService.submitSSHData(data);
                console.log("SSH Data Submitted Successfully:", response);
                if(response.status=200) {
                          toast.success(response.message)
                        } else {
                          toast.error(response.message)
                        }
                        navigate("/on-premises/scans")
        
                // Reset state on successful submission
        
                //alert("SSH Data submitted successfully!");
            } catch (error) {
                console.error("Error submitting SSH data:", error);
                alert("Failed to submit SSH data. Please try again.");
            }

    };

    return (
        <>
     <Box sx={{ p: 2, overflowY: "auto", height: "calc(100vh - 80px)" }} className="scroll">
      <ReusableSSHAPI
        onDirty={onDirty}
        scheduleOptions={scheduleOptions}
        vendorList={vendorList}
        vendorSelected={vendorSelected}
        component={"api"}
        onCallback={handleCallbackFromSSH}
      />
     </Box>
    </>
    );
};

export default APIComponent;
